import {BaseContainerModel} from '../../base-container.model';
import {bl_wf_issue_dashboard_link_RowClass} from '../../../dbschema/bl_wf_issue_dashboard_link.model';

export class WfIssueDashboardLinkContainerModel extends BaseContainerModel {
  bl_wf_issue_dashboard_link: bl_wf_issue_dashboard_link_RowClass = new bl_wf_issue_dashboard_link_RowClass();
}
